/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { AdvancedSearchResultDto } from '../model/advancedSearchResultDto';
import { AppStatTypcodeDto } from '../model/appStatTypcodeDto';
import { BaseSearchResultDto } from '../model/baseSearchResultDto';
import { LoadSearchResultDto } from '../model/loadSearchResultDto';
import { SearchQuoteDto } from '../model/searchQuoteDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SearchQuotControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Searches the last five quotations
     * Gives the details of the recently created five quotations
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLastFiveQuotationsUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<AdvancedSearchResultDto>>;
    public getLastFiveQuotationsUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AdvancedSearchResultDto>>>;
    public getLastFiveQuotationsUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AdvancedSearchResultDto>>>;
    public getLastFiveQuotationsUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AdvancedSearchResultDto>>(`${this.basePath}/quotation/searchLastFive`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find status of application
     * The current status of the application will be displayed
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQuotStatusUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<AppStatTypcodeDto>>;
    public getQuotStatusUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AppStatTypcodeDto>>>;
    public getQuotStatusUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AppStatTypcodeDto>>>;
    public getQuotStatusUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AppStatTypcodeDto>>(`${this.basePath}/quotation/status`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Shows number of quotations created by a user 
     * Shows number of quotations created by a user 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWorkLoadUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<LoadSearchResultDto>>;
    public getWorkLoadUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LoadSearchResultDto>>>;
    public getWorkLoadUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LoadSearchResultDto>>>;
    public getWorkLoadUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<LoadSearchResultDto>>(`${this.basePath}/quotation/searchWorkLoad`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Track Application
     * Track the application by entering the application number or name and pan card details
     * @param searchQuotDto searchQuotDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveAllPersonalInfoUsingPOST(searchQuotDto: SearchQuoteDto, observe?: 'body', reportProgress?: boolean): Observable<Array<BaseSearchResultDto>>;
    public saveAllPersonalInfoUsingPOST(searchQuotDto: SearchQuoteDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BaseSearchResultDto>>>;
    public saveAllPersonalInfoUsingPOST(searchQuotDto: SearchQuoteDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BaseSearchResultDto>>>;
    public saveAllPersonalInfoUsingPOST(searchQuotDto: SearchQuoteDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (searchQuotDto === null || searchQuotDto === undefined) {
            throw new Error('Required parameter searchQuotDto was null or undefined when calling saveAllPersonalInfoUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<BaseSearchResultDto>>(`${this.basePath}/quotation/track`,
            searchQuotDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gives search results
     * Gives all the search Result based on the search criteria, if no criterion specified gives the default search results   
     * @param searchQuotDto searchQuotDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public savePersonalInfoUsingPOST2(searchQuotDto: SearchQuoteDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AdvancedSearchResultDto>>;
    public savePersonalInfoUsingPOST2(searchQuotDto: SearchQuoteDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AdvancedSearchResultDto>>>;
    public savePersonalInfoUsingPOST2(searchQuotDto: SearchQuoteDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AdvancedSearchResultDto>>>;
    public savePersonalInfoUsingPOST2(searchQuotDto: SearchQuoteDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (searchQuotDto === null || searchQuotDto === undefined) {
            throw new Error('Required parameter searchQuotDto was null or undefined when calling savePersonalInfoUsingPOST2.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AdvancedSearchResultDto>>(`${this.basePath}/quotation/search`,
            searchQuotDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search quotation by date 
     * Displayes the details of quotations created on particular date 
     * @param searchQuotDto searchQuotDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchBydateUsingPOST(searchQuotDto: SearchQuoteDto, observe?: 'body', reportProgress?: boolean): Observable<Array<BaseSearchResultDto>>;
    public searchBydateUsingPOST(searchQuotDto: SearchQuoteDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BaseSearchResultDto>>>;
    public searchBydateUsingPOST(searchQuotDto: SearchQuoteDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BaseSearchResultDto>>>;
    public searchBydateUsingPOST(searchQuotDto: SearchQuoteDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (searchQuotDto === null || searchQuotDto === undefined) {
            throw new Error('Required parameter searchQuotDto was null or undefined when calling searchBydateUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<BaseSearchResultDto>>(`${this.basePath}/quotation/searchByDate`,
            searchQuotDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
